import { ReferenceInput, SelectInput } from "react-admin";
import { Grid } from "@mui/material";
import { graduationRequests } from "api/graduationApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { studentRequests } from "api/studentApi";
import { administrationRequests } from "api/administrationApi";

const SaveForm = () => {
  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <ReferenceInput
            source="academicYearId"
            reference={studentRequests.getAcademicYearsSelect()}
          >
            <SelectInput
              label="Учебна година"
              source="name"
              emptyText={false}
            />
          </ReferenceInput>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="structuralUnitId"
            reference={administrationRequests.getStructuralUnitsSelect()}
          >
            <SelectInput
              optionText="name"
              label="Структурна единица"
              emptyText={false}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <ReferenceInput
            source="type"
            reference={graduationRequests.getInternshipSessionTypesSelect()}
          >
            <SelectInput
              optionText="nameBg"
              label="Тип"
              emptyText={false}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <CustomDateInput
            source="startDate"
            label="Начална дата"
            noTime
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <CustomDateInput
            source="endDate"
            label="Крайна дата"
            noTime
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SaveForm;
